import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from '@knockrentals/knock-react';
import { Formik } from 'formik';

import '../../_attributeInfo.scss';

class AddAttributeModal extends Component {
  render() {
    return (
      <Modal className="attribute-modal">
        <Formik
          initialValues={{ attributeTypeValue: '' }}
          validate={this.validate}
          onSubmit={this.onConfirm.bind(this)}
        >
          {(props) => (
            <form onSubmit={props.handleSubmit} autoComplete="off">
              <ModalHeader>
                <h2>Add New Attribute</h2>
              </ModalHeader>
              <ModalContent>
                <div className="knock-react-flex">
                  <div className="field-label">Property</div>
                  <div className="field-input">
                    <i className="fa fa-building" /> {this.props.property.name}
                  </div>
                </div>
                <div className="knock-react-flex">
                  <div className="field-label">Attribute Type</div>
                  <div className="field-input field-wrap">
                    <i className="fa fa-tags" />{' '}
                    {this.props.attributeType.attribute_type}
                  </div>
                </div>
                <div className="knock-react-flex">
                  <div className="field-label">Attribute Value</div>
                  <div className="field-input">
                    <input
                      name="attributeTypeValue"
                      type="text"
                      onChange={props.handleChange}
                      value={props.values.attributeTypeValue}
                      className="knock-react-input"
                    />
                    {!!props.errors.attributeTypeValue && (
                      <span className="knock-react-form-hint knock-react-form-hint-error">
                        {props.errors.attributeTypeValue}
                      </span>
                    )}
                  </div>
                </div>
                <div className="knock-react-flex">
                  <div className="field-label">Suggestions</div>
                  <div className="field-input field-wrap">
                    {this.props.suggestions.length ? (
                      this.props.suggestions.map((suggestion, i) => {
                        return (
                          <a
                            key={`suggestion-${i}`}
                            className="mRight10"
                            onClick={this.loadSuggestion.bind(
                              this,
                              suggestion,
                              props
                            )}
                            href="#"
                          >
                            {suggestion}
                          </a>
                        );
                      })
                    ) : (
                      <em>None</em>
                    )}
                  </div>
                </div>
              </ModalContent>
              <ModalFooter>
                <button
                  className="btn-md btn-primary"
                  onClick={this.onCancel.bind(this)}
                  type="button"
                >
                  <i className="fa fa-lg fa-times-circle" /> Cancel
                </button>
                <button className="btn-md btn-success" type="submit">
                  <i className="fa fa-lg fa-check-circle" /> Add Attribute
                </button>
              </ModalFooter>
            </form>
          )}
        </Formik>
      </Modal>
    );
  }

  validate(values) {
    const errors = {};

    if (!values.attributeTypeValue.trim()) {
      errors.attributeTypeValue = 'Required';
    }

    return errors;
  }

  loadSuggestion(suggestion, formProps) {
    formProps.setFieldValue('attributeTypeValue', suggestion);
  }

  onConfirm(values) {
    this.props.createAttribute(
      this.props.property.id,
      this.props.attributeType.id,
      values.attributeTypeValue.trim()
    );
  }

  onCancel() {
    this.props.toggleModal(false);
  }
}

export default AddAttributeModal;
